import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { TrainingDtls } from '../../../models/trainings/training-dtls';
import { trainingsService } from '../../services/trainings/trainings.service';

export const TrainingsInitialDtlsResolver: ResolveFn<Observable<TrainingDtls>> = (route, state) => {
    return inject(trainingsService).getInitialDtls().pipe();
};
